import React from 'react';
import { FaCheck } from 'react-icons/fa';
import styled from 'styled-components';

const MapLayerCardWrap = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  width: 500px;
  flex-shrink: 0;
  .map-layer-card-content-left {
    display: flex;
    align-items: center;
  }
  :hover {
    background: ${({ theme }) => theme.colorUI20};
  }
  .map-layer-card-image {
    height: 120px;
    object-fit: cover;
    width: 150px;
    display: flex;
    border-radius: ${({ theme }) => theme.borderRadius};
    margin-right: ${({ theme }) => theme.spacing01};
  }

  .map-layer-card-title {
    font-size: ${({ theme }) => theme.fontSize03};
    font-weight: ${({ theme }) => theme.fontWeightMedium};
    color: ${({ theme }) => theme.colorText70};
    margin-bottom: ${({ theme }) => theme.spacing01};
  }

  .map-layer-card-description {
    font-size: 14px;
    color: ${({ theme }) => theme.colorText50};
  }

  .map-layer-card-stripe-checked {
    width: ${({ theme }) => theme.spacing05};
    border-radius: ${({ theme }) => theme.borderRadius};
    background: ${({ theme }) => theme.colorPrimary70};
    height: 100%;
    position: absolute;
    right: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    &-icon {
      color: white;
      font-size: ${({ theme }) => theme.fontSize03};
    }
  }
`;

export default function MapLayerCard({ name, image, checked, onClick, index, id }) {
  return (
    <MapLayerCardWrap tabIndex={index} onClick={() => onClick(id)}>
      <div className="map-layer-card-content-left">
        <img className="map-layer-card-image" src={image} alt="" />
        <div>
          <div className="map-layer-card-title">{name()}</div>
        </div>
      </div>
      {checked && (
        <div className="map-layer-card-stripe-checked">
          <FaCheck className="map-layer-card-stripe-checked-icon" />
        </div>
      )}
    </MapLayerCardWrap>
  );
}
